export default "__VITE_ASSET__188ebb26__"